import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError } from 'rxjs';
import { HttpErrorHandler } from '../services/handlers/http-error-handler.service';

export const errorInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const errorHandler = inject(HttpErrorHandler);
  return next(req).pipe(
    catchError( (err) => errorHandler.handle(err, req, next) )
  );
};
